import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';
import { waitForProfile } from './shared.guard';

export const verifiedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const notifications = inject(NotificationService);

  if (authService.emailVerified()) {
    return true;
  }

  return waitForProfile(() => {
    if (authService.emailVerified()) {
      return true;
    }
    notifications.show(
      'verify',
      'Verifica tu email',
      'Necesitas verificar tu correo electrónico para continuar.',
    );
    return router.createUrlTree(['/verify-email']);
  }, true);
};
